import * as React from "react";

import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
// import Grid from "@mui/material/Grid";
import Header from "../components/layout/Header";
import GlobalMenu from "../components/layout/GlobalMenu";
// import Copyright from "../components/Copyright";
import NotificationAlert, { NotificationAlertProvider } from "../components/NotificationAlert";

// import { styled } from '@mui/system';
// スマホ対応
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

interface MainLayoutProps {
    children: React.ReactNode;
    title: string;
}

export default function MainLayout({ children, title }: MainLayoutProps) {
    const theme = useTheme();
    //const theme = useTheme();
    // md (900px) 以上なら true、未満（スマホ・タブレット）なら false が自動で入る
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    // メニューの開閉状態（初期値はデスクトップなら開く、スマホなら閉じる）
    const [open, setOpen] = React.useState(isDesktop);
    // 画面サイズが変わったときに、自動でメニューの開閉を連動させる

    React.useLayoutEffect(() => {
        setOpen(isDesktop);
    }, [isDesktop]);

    const toggleDrawer = () => {
        setOpen(!open);
    };

    return (
        <Box sx={{ display: "flex", height: "100vh", width: "100vw" }}>
            <CssBaseline />
            <Header isDrawerOpen={open} toggleDrawer={toggleDrawer} title={title} />
            
            {/* GlobalMenu を置くだけ */}
            <GlobalMenu isDrawerOpen={open} toggleDrawer={toggleDrawer} />

            <Box 
                component="main" 
                sx={{ 
                    flexGrow: 1, 
                    overflow: "auto",
                    pt: { xs: "56px", sm: "64px" } 
                }}
            >
                <NotificationAlertProvider>
                    <NotificationAlert />
                    {children}
                </NotificationAlertProvider>
            </Box>
        </Box>
    );
}
